












import { Component, Vue, Provide, Watch } from "vue-property-decorator";
import { State, Getter, namespace, Action } from "vuex-class";
import { IPortalUser } from "../models/interfaces/authentication/portal-user.model.interface";
import { IProperty } from "../models/interfaces/property/property.model.interface";

const UserModule = namespace("userModule");
const PublisherModule = namespace("publisherModule");

@Component({})
export default class PropertySelector extends Vue {
  @UserModule.Getter public user: IPortalUser;
  @PublisherModule.Getter public assignedProperties: IProperty[];
  @PublisherModule.Getter public selectedProperty: IProperty;
  @PublisherModule.Action public setSelectedProperty;
  @PublisherModule.Action public retrieveUserProperties;

  @Provide() public properties: IProperty[] = [];

  @Provide() public property: IProperty | null = null;

  get getProperties(): IProperty[] {
    return this.assignedProperties;
  }

  get getSelectedProperty(): IProperty {
    return this.selectedProperty;
  }

  @Watch("getSelectedProperty")
  public onSelectedPropertyChanged() {
    this.property = this.getSelectedProperty;
  }

  public created() {
    this.retrieveUserProperties(this.user.id).then((result) => {
      this.properties = this.getProperties;
      if (this.getSelectedProperty === null) {
        this.setSelectedProperty(this.properties[0]);
      }

      this.property = this.getSelectedProperty;
    });
  }
}
